// Add these imports near the top with your others
import NotificationPlaydateWorkflow from "./NotificationPlaydateWorkflow"; // create this file
import {
    Notification,
} from "gql/types"; // already imported

interface NotificationActionWorkflowProps {
    notification: Notification;
    user: any; // Replace 'any' with your User type if you have it
    onClose: () => void;
    baseZIndex?: number;
    onDataChange: (success: boolean) => void;
}

const NotificationActionWorkflow: React.FC<NotificationActionWorkflowProps> = ({
    notification,
    user,
    onClose,
    baseZIndex,
    onDataChange,
}) => {
    if (notification.metadata?.__typename === "PlaydateNotificationMetadata") {
        return (
            <NotificationPlaydateWorkflow
                notification={notification}
                user={user}
                onClose={onClose}
                baseZIndex={baseZIndex}
                onDataChange={onDataChange}
            />
        );
    }

    onClose();
    // If no supported workflow, just render nothing
    return <></>;
};

export default NotificationActionWorkflow;
